export const UserPermissionModel = Symbol.for('UserPermissionModel');
